import { render, staticRenderFns } from "./admin-drawer.component.vue?vue&type=template&id=9578fb06&scoped=true"
import script from "./admin-drawer.component.ts?vue&type=script&lang=ts&external"
export * from "./admin-drawer.component.ts?vue&type=script&lang=ts&external"
import style0 from "./admin-drawer.component.vue?vue&type=style&index=0&id=9578fb06&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9578fb06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9578fb06')) {
      api.createRecord('9578fb06', component.options)
    } else {
      api.reload('9578fb06', component.options)
    }
    module.hot.accept("./admin-drawer.component.vue?vue&type=template&id=9578fb06&scoped=true", function () {
      api.rerender('9578fb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/admin-drawer/admin-drawer.component.vue"
export default component.exports